import React from "react";
import { Box, Grid } from "@mui/material";
import { info } from "../../info/Info";
import Style from "./Experience.module.scss";

export default function Experience({ innerRef }) {
    return (
        <Box
            ref={innerRef}
            id={"experience"}
            mt={"3rem"}
            px={{ xs: "1rem", md: "2rem" }}
            maxWidth={"1200px"}
            mx={"auto"}
        >
            <Box className={Style.sectionTitle}>
                <p className={Style.subtitle}>Career Snapshot</p>
                <h1>Experience, Certifications & Education</h1>
            </Box>
            <Grid container spacing={3} alignItems={"flex-start"}>
                <Grid item xs={12} md={8}>
                    <Box className={Style.timeline}>
                        {info.experience.map((role, index) => (
                            <Box key={index} className={Style.timelineItem}>
                                <Box className={Style.card}>
                                    <span className={Style.eyebrow}>{role.accent}</span>
                                    <h2>{role.role}</h2>
                                    <h3>{role.company}</h3>
                                    <p className={Style.meta}>{role.location} | {role.period}</p>
                                    <ul className={Style.highlights}>
                                        {role.highlights.map((highlight, highlightIndex) => (
                                            <li key={highlightIndex}>{highlight}</li>
                                        ))}
                                    </ul>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Box className={Style.stack}>
                        <Box className={Style.miniCard}>
                            <p className={Style.subtitle}>Certifications</p>
                            <div className={Style.badgeList}>
                                {info.certifications.map((certification, index) => (
                                    <span key={index} className={Style.badge}>{certification}</span>
                                ))}
                            </div>
                        </Box>
                        <Box className={Style.miniCard}>
                            <p className={Style.subtitle}>Education</p>
                            {info.education.map((item, index) => (
                                <div key={index} className={Style.eduItem}>
                                    <h3>{item.degree}</h3>
                                    <p>{item.school}</p>
                                </div>
                            ))}
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
